import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest } from "../services/index";

const API_URL = "/api/companies";

// Fetch Companies
export const fetchCompanies = createAsyncThunk("companies/fetch", async () => {
  const response = await hrmsGetRequest(API_URL);
  return response.data;
});

// Add Company
export const addCompany = createAsyncThunk("companies/add", async (companyData) => {
  const response = await hrmsPostRequest(API_URL, companyData);
  return response.data;
});

const companySlice = createSlice({
  name: "companies",
  initialState: {
    companies: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanies.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.companies = action.payload;
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addCompany.fulfilled, (state, action) => {
        state.companies.push(action.payload);
      });
  },
});

export default companySlice.reducer;